// extracted by mini-css-extract-plugin
export var main = "Layout-module--main--Fiv02";
export var wrapper = "Layout-module--wrapper--4nUNR";